import {
  Card,
  CardContent,
  Typography,
  Box,
  Skeleton,
  Stack,
} from "@mui/material";
import PlayerCard from "./PlayerCard";

/**
 * Displays a lineup of players as cards
 * @param {Object} props
 * @param {Array} props.lineup - Array of player data
 * @param {boolean} props.loading - Whether the lineup is loading
 * @param {Function} props.onCardClick - Optional callback when a card is clicked
 */
export default function PlayerLineup({
  lineup = [],
  loading = false,
  onCardClick,
}) {
  if (loading) {
    return (
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {[...Array(6)].map((_, index) => (
          <Card
            key={`skeleton-${index}`}
            sx={{
              width: 120,
              flexShrink: 0,
            }}
          >
            <Box sx={{ position: "relative" }}>
              <Skeleton variant="rectangular" height={120} animation="wave" />
              <Box
                sx={{
                  position: "absolute",
                  top: 5,
                  left: 5,
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  bgcolor: "rgba(0, 0, 0, 0.3)",
                }}
              />
            </Box>
            <CardContent sx={{ p: 1 }}>
              <Skeleton variant="text" width="80%" animation="wave" />
              <Skeleton
                variant="text"
                width="60%"
                height={10}
                animation="wave"
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  }

  if ((!lineup || lineup.length === 0) && !loading) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ py: 5, bgcolor: "background.paper", borderRadius: 1 }}
      >
        <Typography variant="h6" color="text.secondary">
          No players available
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {lineup.map((option) => (
        <PlayerCard
          key={option.id}
          card={option}
          variant="lineup"
          width={120}
          onClick={onCardClick ? () => onCardClick(option) : undefined}
        />
      ))}
    </Box>
  );
}
